import { Routes } from "@angular/router";

export const appRoutes: Routes = [
  {
    path: "applications/move",
    loadChildren: () =>
      import("./modules/applications/move-application/move-application.routes").then(
        (m) => m.routes,
      ),
  },
  {
    path: "approvals/:id",
    title: "Tillkoppla er fastighet | Kalmar Energi",
    loadComponent: () =>
      import("./modules/approval/approval.component").then(
        (c) => c.ApprovalComponent,
      ),
  },
  {
    path: "customer/agent",
    loadComponent: () =>
      import("./modules/customer-agent/customer-agent.component").then(
        (c) => c.CustomerAgentComponent,
      ),
  },
  {
    path: "static/ok",
    loadComponent: () =>
      import("./modules/static/ok/ok.component").then((c) => c.OkComponent),
  },
  {
    path: "**",
    loadComponent: () =>
      import("@kalmarenergi/features").then((c) => c.NotFoundComponent),
  },
];
